export const SquadCaptain = (props: React.JSX.IntrinsicElements['svg']) => {
  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 24 22"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <filter
        id="a"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="21.0399"
        width="22.8359"
        x=".58368"
        y=".963222"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy=".658718" />
        <feGaussianBlur stdDeviation="2.30551" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0.3 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow_12039_69701"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12039_69701"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        id="b"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="11.5329"
        width="13.4249"
        x="5.31486"
        y="5.16173"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy=".10273" />
        <feGaussianBlur stdDeviation=".154095" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.866667 0 0 0 0 0.32549 0 0 0 0.2 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow_12039_69701"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_12039_69701"
          mode="normal"
          result="shape"
        />
      </filter>
      <linearGradient
        id="c"
        gradientUnits="userSpaceOnUse"
        x1="19.6534"
        x2="5.9459"
        y1="11.6725"
        y2="10.154"
      >
        <stop offset=".100088" stopColor="#008787" />
        <stop offset=".305105" stopColor="#85ffdb" />
        <stop offset=".682379" stopColor="#53efef" />
        <stop offset=".942122" stopColor="#008787" />
      </linearGradient>
      <g filter="url(#a)">
        <path
          d="m12.8744 5.47597c-1.8193-.35299-3.92653-.66992-5.22879-.5239-.5165.05792-.85775.4978-.95998 1.00738l-1.46039 7.27945c-.10671.5319.06458 1.0813.54852 1.3265 1.13188.5736 3.23043 1.2046 5.48394 1.6608 2.117.4285 3.6687.5559 4.7177.4911.6018-.0372 1.0482-.5122 1.1823-1.1l1.61-7.05828c.1212-.53113-.0226-1.10234-.4855-1.38964-1.1579-.71877-3.1153-1.24861-5.4078-1.69341z"
          fill="#002624"
        />
      </g>
      <g filter="url(#b)">
        <path
          d="m16.7009 16.0325.1537-.7468-.0092-.0016.1893-.92.0092.0016.3298-1.6024-.0093-.0016.1893-.92.0093.0016.3297-1.6024-.0092-.0016.1893-.91994.0092.00158.2961-1.43716c.0803-.38831-2.3191-1.21031-5.3591-1.8353-3.03955-.62585-5.5683-.81758-5.64863-.42926l-.29611 1.43715.00614.00105-.1893.91998-.00614-.00105-.32975 1.6024.00615.00105-.1893.92-.00615-.0011-.32974 1.6024.00614.0011-.1893.92-.00614-.0011-.15368.7469c-.00204.01-.00148.0215-.00045.0321l-.00863.0412.02237.0042c.2086.4121 2.49515 1.1715 5.34492 1.7573 3.04.625 5.5683.8176 5.6478.4288zm-3.748-9.66407c2.3444.48197 4.2089 1.04461 4.166 1.25632-.0437.21126-1.9793-.00733-4.3233-.49018-2.3444-.48197-4.20887-1.04461-4.16601-1.25632.04372-.21125 1.97931.00734 4.32331.49018zm-5.48592.7684.58161.12004-.1893.91998-.58161-.12004zm-.51904 2.52238.5816.12003-.1893.91996-.58161-.12zm-.70835 3.44239.1893-.92.5816.12-.1893.92zm5.17981 1.0153-.1126-.0233c-2.51059-.5161-2.84419-2.2633-2.61274-3.3853l.04576-.2213c.23559-1.14442 1.22064-2.56613 3.73078-2.04918l.1126.02337c2.3041.47381 2.8399 1.76151 2.6248 2.80291l-.0035.0149-1.5652-.3221c.0097-.1602.1896-.931-1.2581-1.2283-1.3438-.27635-1.9193.3901-2.0718 1.1286l-.0218.1035c-.14.6793.1185 1.6332 1.4545 1.9076 1.4625.3008 1.5824-.4977 1.6414-.6706l1.5651.3221-.0041.0223c-.2067 1.0046-1.1925 2.056-3.526 1.5766zm5.7251-4.99015.5426.11147-.1893.91998-.5426-.1115zm-.519 2.52235.5426.1115-.1893.92-.5426-.1115zm-.5191 2.5224.5427.1115-.1894.9199-.5426-.1114z"
          fill="url(#c)"
        />
        <path
          d="m16.7133 16.0682.0059.0032.0069-.0337.1537-.7469.0053-.026-.0092-.0015.1789-.8697.0093.0016.005-.0243.3297-1.6024.0054-.026-.0092-.0016.1789-.8697.0092.0016.005-.0243.3298-1.6024.0053-.026-.0092-.0016.1789-.86964.0093.00158.005-.02432.2961-1.43713zm0 0c-.0238.0463-.0768.0806-.146.1063-.0858.0319-.2056.0541-.3543.0676-.2978.027-.7179.0197-1.2294-.0191-1.0234-.0778-2.4166-.2824-3.9373-.5951-1.42564-.293-2.71073-.6295-3.66584-.9445-.47747-.1575-.87306-.3097-1.16269-.4487-.14478-.0695-.26369-.1359-.3533-.1984-.08299-.0578-.1434-.1139-.1747-.1678l-.01033-.0019-.02585-.0048.00539-.0257.00784-.0375c-.00087-.0104-.00132-.0233.00119-.0357l.00002-.0001.15368-.7469.00501-.0243.00614.0011.17894-.8697-.00614-.001.00535-.026.32975-1.6024.005-.0244.00615.0011.17894-.86966-.00614-.00105.00535-.02602.32975-1.6024.005-.02432.00614.00105.17895-.86964-.00615-.00105.00536-.02602.2961-1.43715.00001-.00002c.01294-.06257.0732-.10639.15733-.13759.0859-.03186.20576-.05404.35455-.06755.29796-.02704.71823-.0198 1.22982.01905 1.02358.07773 2.41678.28232 3.93728.5954m3.6891 10.04487-3.6891-10.04487m0 0c1.5207.31264 2.8817.67464 3.8528 1.00726.4854.16624.8744.32547 1.1374.46791.1313.07113.2326.13881.2989.20198.0649.06186.1029.1259.09.18849zm-.0765.37026v-.00001c-1.1715-.24131-2.2406-.41652-3.02195-.50501-.39083-.04425-.70893-.06673-.93163-.06507-.11156.00083-.19784.00772-.25694.02046-.02966.00639-.05091.01394-.06476.02193-.01401.00807-.01705.01451-.01768.01756l-.02515-.0052m4.31811.51534 4.1284 1.24353c-.0139.00798-.0351.01553-.0648.02192-.0591.01274-.1454.01963-.2569.02046-.2227.00166-.5408-.02081-.9317-.06507-.7814-.08849-1.8504-.26369-3.0219-.50501-1.1717-.24088-2.2232-.50186-2.97603-.72894-.37657-.11359-.67771-.21848-.8817-.30791-.10219-.0448-.17875-.0852-.22806-.12025-.02473-.01759-.0413-.03293-.05089-.04575-.00971-.01297-.00999-.02013-.00936-.02323l-.02517-.00509m4.31811.51534c1.1717.24088 2.2232.50185 2.976.72894.3766.11358.6777.21847.8817.30791.1022.0448.1788.08519.2281.12025.0247.01758.0413.03292.0509.04575.0096.01281.0099.01995.0093.02311zm-4.31811-.51534c-.04286.21171 1.82161.77435 4.16601 1.25632l.1573-.76614c-2.344-.48284-4.27959-.70143-4.32331-.49018zm.08962 4.83525c-.11481.5565-.08919 1.2671.27522 1.9019.36395.6339 1.06797 1.1961 2.31747 1.453h.0001l.1126.0234.0336.007-.0008.0016c1.1448.2292 1.9571.0856 2.5087-.2357.5558-.3237.85-.8297.9526-1.3249l-1.5177-.3123c-.0019.0063-.0039.0131-.006.0204-.0313.1074-.0928.3184-.2894.4824-.2285.1906-.6332.3144-1.3687.1631m-3.01769-2.1799 3.02289 2.1548m-3.02289-2.1548.04576-.2213v-.0001c.11689-.56774.41946-1.2029 1.0025-1.63203.58243-.42864 1.44833-.65444 2.69793-.3971l.1126.02337v.00001c1.1482.23611 1.8518.67418 2.242 1.17916.3873.50129.468 1.07149.3649 1.58319l-1.518-.3124c.0004-.0044.0009-.0091.0014-.014.0106-.1013.0328-.3146-.0889-.5403zm3.01769 2.1799.0052-.0251m-.0052.0251.0052-.0251m-.0052.0251c-.6738-.1383-1.0791-.449-1.2976-.8139-.218-.3642-.2479-.7793-.1769-1.124v-.0001l.0218-.1034m1.4579 2.0163c-1.336-.2744-1.5945-1.2283-1.4545-1.9076l.0218-.1035m-.0252-.0052.0252.0052m-.0252-.0052v-.0001l.0252.0053m-.0252-.0052c.0772-.3737.262-.7318.6-.96091.3382-.22934.8256-.32679 1.5022-.18765l-.0052.02516m-2.0718 1.1286c.1525-.7385.728-1.40495 2.0718-1.1286m0 0c1.3557.2784 1.2841.972 1.2616 1.1906-.0015.0148-.0028.0275-.0035.0377l-1.2529-1.25346zm2.5674 2.7912-.0253-.0047-.004.0219.0247.005m.0046-.0222-.0293.0174-.0001.0003.0248.0045m.0046-.0222-.0046.0222m.0046-.0222-.0041.0223-.0005-.0001m-7.63599-4.50516.17895-.86966.5313.10965-.17895.86967zm.1912 1.76237-.17895.86969-.5313-.1097.17895-.86965zm-.69799 3.39209-.53131-.1097.17895-.8697.5313.1097zm10.18438-3.1646.1789-.86963.4923.10113-.1789.8697zm-.5191 2.5224.179-.8697.4923.1012-.179.8696zm-.519 2.5224.1789-.8697.4923.1012-.1789.8696z"
          stroke="#003f3d"
          strokeWidth=".051365"
        />
      </g>
    </svg>
  );
};
